import styled from 'styled-components'
import { Radio } from 'antd'
export const TicketRadio = styled(Radio)`
  display: block;
  line-height: 40px;
`
